/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateCommentRequest = {
  properties: {
    content: {
      type: 'string',
      isRequired: true,
    },
    entity: {
      type: 'string',
      isRequired: true,
    },
    entityId: {
      type: 'string',
      isRequired: true,
    },
    file: {
      type: 'File',
    },
  },
} as const;
